module.exports = __webpack_public_path__ + "static/img/202.108.135.137.56ef419b.png";